import { getSingleWagesQuery } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getSingleWages/getSingleWagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getSingleWagesQueryOptions = ({
  id,
  damaged_id,
  wages_id,
}: {
  id: number;
  damaged_id: number;
  wages_id: number;
}) =>
  queryOptions({
    queryKey: ['getSingleWages', id, damaged_id, wages_id],
    queryFn: () => getSingleWagesQuery({ id, damaged_id, wages_id }),
    enabled: false,
    select: (data) => {
      return {
        count: data?.count,
        total_price: data?.total_price,
        wages: {
          id: data?.wages?.id,
          title: { label: data?.wages?.title, value: Math.random() },
          price: data?.wages?.price,
        },
      };
    },
  });
